import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Info, Calendar, Image, Mail } from 'lucide-react';

export default function Nav() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const navItems = [
    { path: '/', label: 'Accueil', icon: <Home size={18} className="mr-2" /> },
    { path: '/Apropos', label: 'À propos', icon: <Info size={18} className="mr-2" /> },
    { path: '/Evenement', label: 'Évènements', icon: <Calendar size={18} className="mr-2" /> },
    { path: '/Galerie', label: 'Galerie', icon: <Image size={18} className="mr-2" /> },
    { path: '/Contact', label: 'Contact', icon: <Mail size={18} className="mr-2" /> }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'py-2 bg-gray-900 shadow-lg' : 'py-4 bg-gray-800'}`}>
      <div className="container mx-auto flex justify-between items-center px-4 md:px-8">
        <Link 
          to="/" 
          className="flex items-center text-white text-lg font-bold md:text-xl whitespace-nowrap hover:text-yellow-400 transition-colors"
        >
          <span className="bg-yellow-500 text-gray-900 rounded-full w-8 h-8 flex items-center justify-center mr-2">
            PC
          </span>
          PERSPECTIVE CONGO
        </Link>
        
        <button
          className="text-white md:hidden focus:outline-none p-2"
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <div className={`w-6 h-0.5 bg-white transition-all ${isOpen ? 'rotate-45 translate-y-1.5' : 'mb-1.5'}`}></div>
          <div className={`w-6 h-0.5 bg-white transition-all ${isOpen ? 'opacity-0' : 'mb-1.5'}`}></div>
          <div className={`w-6 h-0.5 bg-white transition-all ${isOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></div>
        </button>

        <div className={`fixed inset-0 bg-gray-900 bg-opacity-95 z-40 flex flex-col items-center justify-center md:relative md:flex md:bg-transparent md:inset-auto transition-all duration-300 ${isOpen ? 'opacity-100 translate-x-0' : 'opacity-0 md:opacity-100 translate-x-full md:translate-x-0'}`}>
          <button
            className="absolute top-6 right-6 text-white md:hidden"
            onClick={closeMenu}
            aria-label="Fermer le menu"
          >
            <div className="w-6 h-0.5 bg-white rotate-45"></div>
            <div className="w-6 h-0.5 bg-white -rotate-45 -translate-y-0.5"></div>
          </button>

          <ul className="flex flex-col items-center space-y-8 md:flex-row md:space-y-0 md:space-x-6 lg:space-x-8">
            {navItems.map((item, index) => (
              <li key={index}>
                <Link 
                  to={item.path} 
                  onClick={closeMenu}
                  className={`flex items-center px-3 py-2 rounded-lg transition-all ${location.pathname === item.path 
                    ? 'bg-yellow-500 text-gray-900 font-medium' 
                    : 'text-white hover:bg-gray-700 hover:text-yellow-400'}`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}